import { render } from "./HomeView.vue?vue&type=template&id=12c942de&scoped=true&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=12c942de&scoped=true&lang=scss"

import exportComponent from "E:\\vue-next\\divination_by_coin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c942de"]])

export default __exports__